import React, { useState } from "react";
import moment from "moment";

export default function UploadPreview(props) {
  const {
    crrFieldType = [],
    saveEmpList = [],
    loadedDataSheet = [],
    closeUploadPreview,
    saveUploadEmployee,
    handleChange,
    SheetJSFT,
  } = props;

  const [showFilter, setShowFilter] = useState(false);
  const [showFilter2, setShowFilter2] = useState(null);



  // ✅ Extract columns from uploaded file
  const FieldList = Array.from(
    new Set(
      loadedDataSheet.flatMap((row) => Object.keys(row || {}))
    )
  );

  // ✅ Helper
  const getCrrFieldType = (field) =>
    crrFieldType.find((f) => f.field === field)?.option || "";

  // ✅ VALIDATION
  let issues = [];
  let empIdMap = {};

  loadedDataSheet.forEach((row, rowIndex) => {
    FieldList.forEach((field, colIndex) => {
      const value = row[field];

      // 🔹 Date validation
      if (getCrrFieldType(field) === "Date (DD-MM-YYYY)") {
        if (value && !moment(value, "DD-MM-YYYY", true).isValid()) {
          issues.push(
            `Invalid date at row ${rowIndex + 1}, column ${colIndex + 1}`
          );
        }
      }

      // 🔹 Special char validation (column name)
      if (/[^a-zA-Z0-9_\-]/.test(field) && field !== "mobile") {
        issues.push(`Invalid column name: ${field}`);
      }

      // 🔹 Duplicate mobile
      if (field === "mobile" && value) {
        empIdMap[value] = (empIdMap[value] || 0) + 1;
      }
    });
  });

  Object.entries(empIdMap).forEach(([key, count]) => {
    if (count > 1) {
      issues.push(`Duplicate mobile: ${key}`);
    }
  });

  // Mandatory fields
  if (!FieldList.includes("email"))
    issues.push("Missing 'email' column");
  if (!FieldList.includes("mobile"))
    issues.push("Missing 'mobile' column");

  // ✅ Success Message
  let successMsg = "";
  if (saveEmpList.length > 0) {
    let total = 0,
      modified = 0;

    saveEmpList.forEach((d) => {
      total += d.ok || 0;
      modified += d.nModified || 0;
    });

    successMsg = `Modified: ${modified}, Inserted: ${total - modified}`;
  }

  const optionField = ["Date (DD-MM-YYYY)", "Alpha Numeric"];

  return (
    <div className="fixed inset-0 bg-black/60 flex justify-center items-center z-50 px-4">
      <div className="bg-white w-full max-w-5xl rounded-lg shadow-lg overflow-hidden">

        {/* HEADER */}
        <div className="flex justify-between items-center p-4 border-b">
          <h2 className="font-semibold text-lg">Upload Preview</h2>
          <button onClick={closeUploadPreview}>✖</button>
        </div>

        {/* SUCCESS */}
        {successMsg ? (
          <div className="p-10 text-center">
            <h2 className="text-green-600 text-xl font-semibold">
              Upload Successful
            </h2>
            <p className="text-gray-500 mt-2">{successMsg}</p>
          </div>
        ) : (
          <>
            {/* ONBOARDING FIELD */}
            <div className="py-4 px-6 flex justify-between items-center">
              <span className="font-semibold">Verify Uploaded Details</span>

            </div>

            {/* TABLE */}
            <div className="overflow-auto max-h-72 px-6">
              <table className="min-w-full text-sm">
                <thead className="bg-gray-100 sticky top-0">
                  <tr>
                    {FieldList.map((f, i) => (
                      <th key={i} className="p-2 border">{f}</th>
                    ))}
                  </tr>
                </thead>

                <tbody>
                  {loadedDataSheet.map((row, i) => (
                    <tr key={i} className="odd:bg-gray-50">
                      {FieldList.map((f, j) => (
                        <td key={j} className="p-2 border text-center">
                          {row[f]}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* ISSUES */}
            {issues.length > 0 && (
              <div className="p-4">
                <h3 className="text-red-600 font-semibold">
                  Validation Errors
                </h3>
                <div className="max-h-32 overflow-auto mt-2 border p-2">
                  {issues.map((err, i) => (
                    <p key={i} className="text-xs text-red-500">
                      {i + 1}. {err}
                    </p>
                  ))}
                </div>
              </div>
            )}

            {/* FOOTER */}
            <div className="p-6 flex justify-end items-center">
              {issues.length === 0 ? (
                <button
                  onClick={saveUploadEmployee}
                  className="bg-blue-600 text-white px-4 py-2 rounded"
                >
                  Finalize Import
                </button>
              ) : (
                <label className="cursor-pointer border px-4 py-2 rounded">
                  Reupload
                  <input
                    type="file"
                    hidden
                    accept={SheetJSFT}
                    onChange={handleChange}
                  />
                </label>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
}